/*
 *
 * ----------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  var button = document.querySelector(".btn-toggle-open");

  if (button) {
    var targetSelector = button.getAttribute("data-bs-target");
    var target = document.querySelector(targetSelector);

    if (target) {
      button.addEventListener("click", function () {
        setTimeout(function () {
          // Delay to wait for Bootstrap's collapse to complete
          var isExpanded = button.getAttribute("aria-expanded") === "true";
          button.textContent = isExpanded ? "少なく表示する" : "もっと見る";
        }, 350); // Duration should match the collapse animation duration
      });
    }
  }
});
